var render = function render(){var _vm=this,_c=_vm._self._c;return _c('users-table',{attrs:{"headers":_vm.headers,"users":_vm.users},on:{"triggerPageChange":function($event){return _vm.readPaginatedUsers($event)},"deleteUser":function($event){return _vm.deleteUser($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }